/* eslint-disable */

export const CommerceMoneyLineKind = {
  Subtotal: 'subtotal',
  Discount: 'discount',
  LedgerCredit: 'ledger_credit',
  Tax: 'tax',
  Fee: 'fee',
  StartupFee: 'startup_fee',
  DueNow: 'due_now',
  Future: 'future',
  Recurring: 'recurring'
} as const;
export type CommerceMoneyLineKind = typeof CommerceMoneyLineKind[keyof typeof CommerceMoneyLineKind];
